var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Snackbar } from '@material-ui/core';
import { createContext, useCallback, useContext, useState } from 'react';
import { useSnackbarStyles, useSnackbarVariantStyles } from './style';
import { Variant } from './types';
import Notification from './Notification';
var NotificationContext = createContext(function () {
    console.log('You forgot to wrap your component in NotificationProvider.');
});
export var useNotification = function () { return useContext(NotificationContext); };
export var NotificationProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var _d = useState(Variant.success), variant = _d[0], setVariant = _d[1];
    var snackbarClasses = useSnackbarStyles();
    var variantClasses = useSnackbarVariantStyles();
    var showNotification = useCallback(function (message, variant) {
        if (variant === void 0) { variant = Variant.success; }
        setOpen(true);
        setMessage(message);
        setVariant(variant);
    }, []);
    var handleClose = function () {
        setOpen(false);
        setMessage('');
    };
    return (_jsxs(_Fragment, { children: [_jsx(NotificationContext.Provider, __assign({ value: showNotification }, { children: children }), void 0),
            _jsx(Snackbar, __assign({ open: open, autoHideDuration: 3000, onClose: handleClose, message: message, classes: snackbarClasses, className: variantClasses[variant] }, { children: _jsx(Notification, { onClose: handleClose, variant: variant, message: message }, void 0) }), void 0)] }, void 0));
};
